export default __webpack_public_path__ + "static/media/regulatory--one-way-right--g3.9cdca710.png";